export const SPEnergyIndexIcon = () => <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.6665 2.16667L4.99984 11.3333H9.99984L8.33317 18.8333L14.9998 9.66667H9.99984L11.6665 2.16667Z" stroke="#D25D3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M10 10.5C10 10.5 10 10.5 10 10.5Z" stroke="#D25D3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
